var _style, _circle, _defs, _path, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransactionRecordsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000015316014461419187160000000148016032552327299_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 184.3 167.6",
    style: {
      enableBackground: "new 0 0 184.3 167.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.3;fill:#FFD500;enable-background:new    ;}\r\n\t.st1{clip-path:url(#SVGID_00000047757471987217831840000017126891991786021017_);}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{opacity:0.5;fill:#FFD500;enable-background:new    ;}\r\n\t.st4{fill:#E3E6ED;}\r\n\t.st5{fill:#626975;}\r\n\t.st6{fill:#7AD49E;}\r\n\t.st7{fill:#FFB000;}\r\n\t.st8{fill:#8ADBEF;}\r\n")), /*#__PURE__*/React.createElement("g", null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 109.8,
    cy: 65.8,
    r: 65.8
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M15,33.2h116.6c7.4,0,13.5,6,13.5,13.5v101.2c0,7.4-6,13.5-13.5,13.5H15c-7.4,0-13.5-6-13.5-13.5V46.7 C1.5,39.3,7.5,33.2,15,33.2z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "#FFFAEB"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000004541564368741291330000000537789934985150627_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000004541564368741291330000000537789934985150627_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0,54.6c0-1.3,1.1-2.4,2.4-2.4h18.1c0.9,0,1.7-0.5,2.1-1.3l3.9-7.3c0.4-0.8,1.2-1.3,2.1-1.3h40 c0.9,0,1.7,0.5,2.1,1.3l3.8,7.3c0.4,0.8,1.2,1.3,2.1,1.3h102v115.4H2.4c-1.3,0-2.4-1.1-2.4-2.4V54.6z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#FFD500",
      strokeWidth: 1.77
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M31.9,45.9L31.9,45.9c1.3,0,2.4,1.1,2.4,2.4l0,0c0,1.3-1.1,2.4-2.4,2.4l0,0c-1.3,0-2.4-1.1-2.4-2.4l0,0 C29.5,47,30.6,45.9,31.9,45.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M39,47.1h17.7c0.7,0,1.2,0.5,1.2,1.2l0,0c0,0.7-0.5,1.2-1.2,1.2H39c-0.7,0-1.2-0.5-1.2-1.2l0,0 C37.8,47.6,38.3,47.1,39,47.1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M76.3,127.9h47.4c1.1,0,2-0.9,2-2s-0.9-2-2-2H76.3c-1.1,0-2,0.9-2,2S75.2,127.9,76.3,127.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M76.3,138.5h47.4c1.1,0,2-0.9,2-2s-0.9-2-2-2H76.3c-1.1,0-2,0.9-2,2S75.2,138.5,76.3,138.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M25.7,150.8h32.1c1.1,0,2-0.9,2-2V67.1c0-1.1-0.9-2-2-2H25.7c-1.1,0-2,0.9-2,2v81.6 C23.7,149.9,24.6,150.8,25.7,150.8C25.7,150.8,25.7,150.8,25.7,150.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "27.8,69.2 55.7,69.2 55.7,146.7 27.8,146.7 27.8,69.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M78.1,67.1H122c1,0,1.8,0.8,1.8,1.8v16.2c0,1-0.8,1.8-1.8,1.8H78.1c-1,0-1.8-0.8-1.8-1.8V68.9 C76.3,67.9,77.1,67.1,78.1,67.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M78.1,94.8H122c1,0,1.8,0.8,1.8,1.8v16.2c0,1-0.8,1.8-1.8,1.8H78.1c-1,0-1.8-0.8-1.8-1.8V96.5 C76.3,95.5,77.1,94.8,78.1,94.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M25.7,67.1h32.1v81.6H25.7C25.7,148.7,25.7,67.1,25.7,67.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M51.7,75.3H31.8c-1.1,0-2,0.9-2,2s0.9,2,2,2h19.9c1.1,0,2-0.9,2-2S52.8,75.3,51.7,75.3z M51.7,90.6H31.8 c-1.1,0-2,0.9-2,2s0.9,2,2,2h19.9c1.1,0,2-0.9,2-2S52.8,90.6,51.7,90.6z M51.7,105.9H31.8c-1.1,0-2,0.9-2,2s0.9,2,2,2h19.9 c1.1,0,2-0.9,2-2S52.8,105.9,51.7,105.9z M51.7,121.2H31.8c-1.1,0-2,0.9-2,2s0.9,2,2,2h19.9c1.1,0,2-0.9,2-2 S52.8,121.2,51.7,121.2z M51.7,136.5H31.8c-1.1,0-2,0.9-2,2s0.9,2,2,2h19.9c1.1,0,2-0.9,2-2S52.8,136.5,51.7,136.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionRecordsIcon);
export default __webpack_public_path__ + "static/media/TransactionRecords-icon.9b80efbc2637cc0b76ad959c608a13fc.svg";
export { ForwardRef as ReactComponent };